import React from "react";
import ReactDOM from "react-dom/client";

import reportWebVitals from "./reportWebVitals";
import Shell from "./shell";
import "./shared/services/languages/i18n";
import { bootstrapSentry } from "./shared/services/Sentry";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

if (import.meta.env.VITE_SENTRY_ACTIVE === "true") {
  bootstrapSentry();
}
root.render(
  <React.StrictMode>
    <Shell />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
